module.exports = __webpack_public_path__ + "img/guide-11.8a2ff197.jpg";